import { createFeatureSelector, createSelector } from '@ngrx/store';
import { IWebsocketState } from '@medlogic/medlogic/medlogic-shared-interfaces';
import * as fromWebsocket from './websocket.reducer';

export const selectWebsocketState = createFeatureSelector<IWebsocketState>(fromWebsocket.websocketFeatureKey);

export const selectWebsockets = createSelector(selectWebsocketState, fromWebsocket.selectAll);

